import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cswhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# While tutorial For Beginners</title>
 <meta name="description" content="C# While tutorial for beginners.While in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# While,c# While for,c sharp While,c# While for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,While foreach c#,c# foreach While" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-while" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C# While loop</h1>
    <div className="first">
        <a href="/csharp-looping-statement">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">While loop for C#:</h2>
    <p className="mt-4 para">This condition will be given and the body of the loop will be executed until the given condition is false</p>
   

<h2 className='headings'>While loop C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
          <span className="qwerty-5">While </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-6">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-7">Statement </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-10">body</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2"> Csharp While loop Example</h2>



<h2 className='headings'>Q-Write a program Addition or increment while loop Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">While</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">1 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-7">(</span>
              <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-6">WriteLine</span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty-6">++</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">OR</span>
            {"\n"} {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3"> +</span>
            <span className="qwerty-10"> 1</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"} 
              <span className="qwerty-10">2 </span>
              {"\n"} 
              <span className="qwerty-10">2 </span>
              {"\n"} 
              <span className="qwerty-10">4 </span>
              {"\n"} 
              <span className="qwerty-10">5 </span>
              {"\n"} 
              <span className="qwerty-10">6 </span>
              {"\n"} 
              <span className="qwerty-10">7 </span>
              {"\n"} 
              <span className="qwerty-10">8 </span>
              {"\n"} 
              <span className="qwerty-10">9 </span>
              {"\n"} 
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program Subtract or decrement in while loop Example in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}{"\n"}
          <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">While</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-1">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-1">a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-7">&#123; </span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-1">a</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">a </span>
            <span className="qwerty-3">--;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">OR</span>
            {"\n"} {"\n"}
            <span className="qwerty-1">a </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-1"> a</span>
            <span className="qwerty-3"> -</span>
            <span className="qwerty-10"> 1</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}
            <span className="qwerty-7">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"} 
              <span className="qwerty-10">8 </span>
              {"\n"} 
              <span className="qwerty-10">7 </span>
              {"\n"} 
              <span className="qwerty-10">6 </span>
              {"\n"} 
              <span className="qwerty-10">5 </span>
              {"\n"} 
              <span className="qwerty-10">4 </span>
              {"\n"} 
              <span className="qwerty-10">3 </span>
              {"\n"} 
              <span className="qwerty-10">2 </span>
              {"\n"} 
              <span className="qwerty-10">1 </span>
              {"\n"}{"\n"}</code>{"\n"}{""}</pre>
        </div>
      </div>




<h2 className='headings'>While loop uses logic operator Example in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">&&</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; = </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">||</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; = </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">While Loop Reverse C#:</h2>


<h2 className='headings'>Q-Write a program to input an integer number and print in reverse in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}{"\n"}
          <span className="qwerty-6">namespace </span>
            <span className="qwerty-3">While</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7"> [] </span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">2560</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">while </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-5">&#62; </span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">% </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">/</span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">2560 </span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program to input found out the sum of digits of integer no in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
          <span className="qwerty-6">namespace</span>
            <span className="qwerty-3"> asd</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">string</span>
            <span className="qwerty-7"> [] </span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">int</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty">2560</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-6">sum</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty">0</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4"> n </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty"> 0</span>
            <span className="qwerty-1"> )</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">sum </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-6">sum</span>
            <span className="qwerty-3"> +</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">/</span>
            <span className="qwerty">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">" </span>
            <span className="qwerty-6">sum </span>
              <span className="qwerty-10">of </span>
              <span className="qwerty-4">Digits</span>
            <span className="qwerty-1"> = </span>
            <span className="qwerty-10">" + </span>
            <span className="qwerty-6">sum</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">sum </span>
              <span className="qwerty-10">of </span>
              <span className="qwerty-4">Digits </span>
              <span className="qwerty-1">=</span>
              <span className="qwerty"> 2843</span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-looping-statement">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Cswhile;